




























































import Vue from 'vue'
import moment from 'moment'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import {
  CALENDAR_EVENT_ASSISTANT_GET_END_DATE, CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY,
  CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  CALENDAR_EVENT_ASSISTANT_GET_START_DATE,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { PeriodicityPlannedCalendarEventEmployee } from '@/types'
import { CalendarEventEmployee } from '@/model/calendarEvent/CalendarEventEmployee'

interface ComponentData {
  gridOptions: GridOptions,
  overlayNoRowsTemplate: string
  panel: number[]
}

export default Vue.extend({
  name: 'CalendarEventEditorFinish',

  components: {
    AgGridVue
  },

  props: {
    step: String,
    isSaveButtonDisabled: Boolean
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('planningPage.name').toString(), field: 'name' },
          { headerName: this.$t('planningPage.comment').toString(), field: 'comment', width: 400 }
        ]
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      panel: [0]
    }
  },

  watch: {
    step (newVal: string): void {
      if(newVal && newVal === '5') {
        setTimeout(() => {
          const saveButton: any = this.$refs['saveButton']
          if (saveButton) {
            saveButton.$el.focus()
          }
        }, 300)
      }
    },
  },

  computed: {
    date (): string {
      const dateStart: Date = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE]

      const dateStartMoment = moment(dateStart)

      let displayDate: string

      if (dateStartMoment.isSame(dateEnd, 'date')) {
        displayDate = dateStartMoment.format('DD.MM.YYYY')
      } else {
        const dateEndMoment = moment(dateEnd)

        displayDate = `${dateStartMoment.format('DD.MM.YYYY')} - ${dateEndMoment.format('DD.MM.YYYY')}`
      }

      return displayDate
    },

    startEndTime (): string {
      const dateStart = moment(this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_START_DATE])
      const dateEnd = moment(this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_END_DATE])

      return `${dateStart.format('HH:mm')} - ${dateEnd.format('HH:mm')}`
    },

    periodicity (): string {
      const periodicityData: PlanningAssistantPeriodicityPayload = this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY]

      let periodicityString: string = ''

      if (periodicityData.isUnique) {
        periodicityString = this.$t('planningPage.unique').toString()

      } else {
        const days: string[] = periodicityData.weekDayList.map((dayNumber: number): string => {
          return moment().day(dayNumber).locale(this.$store.state.selectedUiLanguage.code).format('dd')
        })

        let periodicityNotUnique: Array<string> = []

        if (days.length) {
          periodicityNotUnique.push(days.join(', '))
        }

        periodicityNotUnique.push(`${this.$t('planningPage.everyWeek').toString()} : ${periodicityData.repeatEveryNthWeek}`)

        if (periodicityData.expireAfterRepetitions > 0) {
          periodicityNotUnique.push(`${this.$t('planningPage.endAfterExecutions').toString()} : ${periodicityData.expireAfterRepetitions}`)
        }

        if (periodicityData.expireAfterDate) {
          const date = moment(periodicityData.expireAfterDate).format('DD.MM.YYYY')

          periodicityNotUnique.push(`${this.$t('planningPage.runUntil').toString()} : ${date}`)
        }

        periodicityString = `${periodicityNotUnique.join('<br />')}`
      }

      return periodicityString
    },

    selectedEmployeeList (): CalendarEventEmployee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedCalendarEventEmployee[] {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isPeriodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_PERIODICITY]
    },

    isEditingSerie (): boolean {
      return this.$store.getters[CALENDAR_EVENT_ASSISTANT_GET_IS_EDITING_SERIE]
    },
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLocale).format('DD.MM.YYYY - dddd')
    },

    formatDate (date: Date): string {
      if(date) {
        return moment(date).format('DD.MM.YYYY')
      } else {
        return ''
      }
    },

    onCancelButtonClick (): void {
      this.$emit('cancelButtonClick')
    },

    onSaveButtonClick (): void {
      this.$emit('saveButtonClick')
    },
  },

  mounted (): void { }
})
